import { useMemo, useState } from 'react'

import { Box, Button, Flex, HStack, Heading, Spacer, useDisclosure } from '@chakra-ui/react'

import { useInitialTableState } from '@/components/Table/components/useInitialTableState'
import FullTable from '@/components/Table/FullTable/FullTable'
import { convertTableStateToQuery } from '@/utils/tableHelper'

import TemplateDetailModal from '../components/TemplateDetailModal'
import VariableLibraryModal from '../components/VariableLibraryModal'
import getDocumentTemplateTableColumns from '../constants/documentTemplateTableColumns'
import useDocumentTemplate from '../useDocumentTemplate'

const DocumentTemplateListPage = () => {
  const [modalDetail, setModalDetail] = useState({ show: false, isCreate: true, detail: {} })
  const { isOpen: isLibraryOpen, onOpen: openLibrary, onClose: closeLibrary } = useDisclosure()

  const [storedTableState, setStoredTableState] = useInitialTableState('table_state:documentTemplate', {})
  const query = convertTableStateToQuery(storedTableState)

  const { useFetchDocumentTemplates } = useDocumentTemplate()
  const { data: documentTemplatesResponse, isLoading } = useFetchDocumentTemplates(query)

  const handleRowClick = (row) => {
    const documentTemplate = row?.original

    if (!documentTemplate?._id) {
      return
    }

    setModalDetail({ show: true, isCreate: false, detail: documentTemplate })
  }

  const handleAddTemplate = () => {
    setModalDetail({ show: true, isCreate: true, detail: {} })
  }

  const defaultColumns = useMemo(() => getDocumentTemplateTableColumns(), [])

  return (
    <>
      <TemplateDetailModal modalDetail={modalDetail} setModalDetail={setModalDetail} />
      <VariableLibraryModal isOpen={isLibraryOpen} onClose={closeLibrary} />
      <Box shadow="md" borderWidth="1px" bg="white" w="100%" mb="auto">
        <Flex p={5} align="center" borderBottom="1px solid #d8dbe0">
          <Heading>Template Management</Heading>
          <Spacer />
          <HStack>
            <Button colorScheme="gray" onClick={openLibrary}>
              Manage Library
            </Button>
            <Button colorScheme="green" onClick={handleAddTemplate}>
              Add Template
            </Button>
          </HStack>
        </Flex>

        <Box p={5}>
          <FullTable
            data={Array.isArray(documentTemplatesResponse?.data?.results) ? documentTemplatesResponse.data.results : []}
            rowCount={documentTemplatesResponse?.data?.count ?? 0}
            columnDef={defaultColumns}
            state={storedTableState}
            setState={setStoredTableState}
            handleRowClick={handleRowClick}
            isLoading={isLoading}
          />
        </Box>
      </Box>
    </>
  )
}

export default DocumentTemplateListPage
